<script>
import { Pie } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    extends: Pie,
    props:{
        pieChartData: {type: Array}
    },
    computed: {
        chartData() {
            return this.pieChartData;
        }
    },
    watch: {
        pieChartData() {
            this.setPieChart();
        },
        "$i18n.locale"(val){
            this.setPieChart()
        }
    },
    methods:{
        formatter(value, context){
            return value == 0 ? null : context.chart.data.labels[context.dataIndex]  + ': \n' +  value;
        },
        align(context){
            return context.dataIndex % 2 ? 'end' : 'center'
        },
        offset(context){
            return context.dataIndex % 2 ? 30 : 4
        },
        setPieChart(){
            var labels = []
            var type = Array.isArray(this.$parent.selectedType) ? this.$parent.selectedType[0] : this.$parent.selectedType
            if(type.id != 'all'){
                for(var i=0; i<=5; i++){
                    labels.push(this.$parent.getCategoryText(type.id, i))
                }
            }else{
                for(var j=1; j<=6; j++){
                    labels.push(this.$i18n.t('label.category') + ' ' + j)
                }
            }

            this.addPlugin(ChartDataLabels);

            this.options = {
                plugins: {
                    datalabels: {
                        color: 'white',
                        backgroundColor: "#363636",
                        borderWidth: 1,
                        borderColor: '#909090',
                        borderRadius: 8,
                        formatter: this.formatter,
                        align: this.align,
                        offset: this.offset,
                        textAlign: 'center',
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            };

            // var itemTypes = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            // var label = this.chartData.label.map(i =>{
            //     return itemTypes[i]
            // })

            this.renderChart(
            {
                labels: labels,
                datasets: [
                {
                    backgroundColor: ["#beaed7", "#7aece0", "#6ab8f7", "#ffdb8e", "#feb7d9", "#909090"], //purple, green, blue, yellow, red, grey
                    data: this.chartData
                }]
            },
            this.options
            );
        },
    },
    mounted() {
        this.setPieChart()
    }
};
</script>